const rome = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});
function localStamp(date) {
  const p = Object.fromEntries(rome.formatToParts(date).map(({ type, value }) => [type, value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}
export function italianScheduleUTC(local) {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:00(?::00)?$/.test(local)) {
    throw new Error('Choose a valid date and a full hour in Italian time.');
  }
  const stamp = local.slice(0, 16);
  const base = Date.parse(`${stamp}:00Z`);
  const matches = [1, 2].map(offset => new Date(base - offset * 3600000))
    .filter(date => Number.isFinite(date.getTime()) && localStamp(date) === stamp);
  if (matches.length !== 1) {
    throw new Error('This Italian hour is missing or repeated during the daylight-saving change. Choose another hour.');
  }
  return matches[0].toISOString().replace('.000Z', 'Z');
}
export function italianScheduleLabel(value) {
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? `${rome.format(date)} (Europe/Rome)` : String(value);
}
